// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3xwC2","buttons":"PendingPaymentAlert_buttons__ik47f"};